import type { StepView } from "../api/types";

/**
 * Whether a failed step's message is worth printing under it.
 *
 * One exception passes through every step it is thrown inside, and each records it on the way out, so a
 * failure three steps deep arrives as the same sentence on the step, on each step around it and on the run.
 * All of them did fail, and each keeps its red rule to say so. The sentence is printed once: on the run, or,
 * where a step failed for a reason the run does not give, on the innermost step that gives it.
 *
 * @param step the step in question.
 * @param steps every step of the run, to find the ones inside [step].
 * @param said what the run already says went wrong, if anything.
 */
export function saysSomethingNew(
  step: StepView,
  steps: StepView[],
  said?: string | null,
): boolean {
  if (!step.error) return false;
  if (step.error === said) return false;
  return !steps.some(
    (inner) => inner.parent === step.id && inner.error === step.error,
  );
}
